// WARNING: This file is auto-generated. Do not modify.
import React, { SVGProps } from 'react';

const ActionEdit = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd" stroke="currentColor">
      <path d="M19.043 3.042l-6.714 6.712a.136.136 0 00-.037.073l-.817 2.572a.136.136 0 00.156.156l2.54-.847a.136.136 0 00.075-.036l6.714-6.713a.136.136 0 000-.193L19.235 3.04A.136.136 0 0019.15 3a.136.136 0 00-.107.04z" />
      <path strokeLinejoin="round" d="M18 10.982V19H5V6h7.907" />
    </g>
  </svg>
);

export default ActionEdit;
